var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "审批详情",
        visible: _vm.visible,
        width: "30%",
        "before-close": _vm.closePup
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _vm.isInDingTalk
        ? [
            _c(
              "el-timeline",
              [
                _c("el-card", { staticStyle: { "margin-bottom": "20px" } }, [
                  _c(
                    "h4",
                    [
                      _vm._v(
                        "申请人：  \n          " +
                          _vm._s(_vm.approvalInof.createUser) +
                          "\n          "
                      ),
                      _c(
                        "el-tag",
                        { attrs: { size: "small", type: "warning" } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.approvalInof.nodes &&
                                _vm.approvalInof.nodes.length > 1
                                ? "顺序审批"
                                : "会审"
                            )
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c("p", [
                    _vm._v("发起时间：  "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.approvalInof.taskCreateTime))
                    ])
                  ])
                ]),
                _vm._l(_vm.approvalInof.nodes, function(item, i) {
                  return [
                    _vm._l(item.taskList, function(task) {
                      return [
                        _c(
                          "el-timeline-item",
                          {
                            key: i + "_" + task.userId,
                            attrs: { color: _vm.compuColor(task) }
                          },
                          [
                            _c("el-card", [
                              _c("h4", [_vm._v(_vm._s(task.name))]),
                              _c(
                                "div",
                                { staticClass: "info-box" },
                                [
                                  _c(
                                    "p",
                                    [
                                      _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            size: "small",
                                            type:
                                              _vm.comstatus(task) === 1
                                                ? "success"
                                                : _vm.comstatus(task) === 2
                                                ? "danger"
                                                : "warning"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.comstatus(task) === 1
                                                ? "已同意"
                                                : _vm.comstatus(task) === 2
                                                ? "已驳回"
                                                : "审批中"
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v("\n                      "),
                                      _c("span", [
                                        _vm._v(_vm._s(task.finishTime))
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm.comstatus(task) === 0
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            plain: "",
                                            size: "mini",
                                            type: "primary",
                                            disabled: _vm.order(
                                              i,
                                              _vm.approvalInof.nodes
                                            )
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.urgentReview(task)
                                            }
                                          }
                                        },
                                        [_vm._v("催审")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ])
                          ],
                          1
                        )
                      ]
                    })
                  ]
                })
              ],
              2
            )
          ]
        : _vm._e(),
      !_vm.isInDingTalk
        ? [
            _c("el-card", { staticStyle: { "margin-bottom": "20px" } }, [
              _c("h4", [
                _vm._v(
                  "申请人：  \n          " +
                    _vm._s(_vm.approName()) +
                    "\n            "
                )
              ]),
              _c("p", [
                _vm._v("发起时间：  "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.approvalInof.approRowInfo &&
                        _vm.approvalInof.approRowInfo.createTime
                    )
                  )
                ]),
                _vm._v("  \n        ")
              ])
            ]),
            _c(
              "el-timeline",
              [
                _vm._l(_vm.approvalInof.instPartyList, function(item, i) {
                  return [
                    _c(
                      "el-timeline-item",
                      {
                        key: i,
                        attrs: {
                          color:
                            item.flowStatus === 1
                              ? "#67C23A"
                              : item.flowStatus
                              ? "#F56C6C"
                              : "#E6A23C"
                        }
                      },
                      [
                        _c("el-card", [
                          _c("h4", [_vm._v(_vm._s(item.userName))]),
                          _c(
                            "div",
                            { staticClass: "info-box" },
                            [
                              _c(
                                "p",
                                [
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        size: "small",
                                        type:
                                          item.flowStatus === 1
                                            ? "success"
                                            : item.flowStatus === 2
                                            ? "danger"
                                            : "warning"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.flowStatus === 1
                                            ? "已同意"
                                            : item.flowStatus === 2
                                            ? "已拒绝"
                                            : "审批中"
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v("\n                    "),
                                  _c("span", [_vm._v(_vm._s(item.flowTime))])
                                ],
                                1
                              ),
                              (_vm.$route.query.signStatus == 5 ||
                                _vm.$route.query.signStatus == 6) &&
                              item.flowStatus === 0
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        plain: "",
                                        size: "mini",
                                        type: "primary",
                                        disabled:
                                          _vm.approvalInof.orderNum &&
                                          i > 0 &&
                                          _vm.approvalInof.instPartyList[i - 1]
                                            .flowStatus !== 1
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.sendApproveSealSms(item)
                                        }
                                      }
                                    },
                                    [_vm._v("催审")]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          [1, 2].includes(item.flowStatus) && item.refuseReason
                            ? _c("div", { staticClass: "approve_reason" }, [
                                _c(
                                  "p",
                                  { staticStyle: { "font-weight": "bold" } },
                                  [_vm._v("审批意见：")]
                                ),
                                _c("span", [_vm._v(_vm._s(item.refuseReason))])
                              ])
                            : _vm._e()
                        ])
                      ],
                      1
                    )
                  ]
                })
              ],
              2
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-267e864e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-267e864e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/corp/signInfo/components/approvalInfoPup.vue
// module id = OV2Z
// module chunks = 27 103 246